{
  "preferences_theme_header": "Theme",
  "preferences_theme_auto_title": "Auto Theme",
  "preferences_theme_auto_description": "Switch automatically with your device.",
  "preferences_theme_default_title": "Default Theme",
  "preferences_theme_default_description": "The beautiful default theme for Dabble.",
  "preferences_theme_dark_title": "Dark Theme",
  "preferences_theme_dark_description": "For writing at night and better brooding."
}